module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/3-5237b4f14803adebb2c09debd92a8ad4.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/3.mp3
// module id = 47
// module chunks = 0